import { formatAmount, parseAmount } from '../../../util';

export type CellValue = number | string | null;

export const parseCellInput = (input: string, isText: boolean): { display: string; value: CellValue } => {
  const trimmed = input.trim();
  if (!trimmed) return { display: '', value: null };
  if (isText) return { display: trimmed, value: trimmed };
  const value = parseAmount(trimmed);
  return { display: formatAmount(value) || '0', value };
};
